import axios from 'axios'

export async function createSession(store, route) {
  if (route.query.credentials) {
    return axios.post(process.env.VUE_APP_API_HOST + "/create_session", {
      credentials: route.query.credentials
    })
  } 
}

export async function getUser() {
  // return { id: 23, name: 'Ahoy' }
  return await axios.get(process.env.VUE_APP_API_HOST + '/cookiemonster').catch(err => {
    console.log(err)
  })
}
